import type { LexicalNode } from "lexical";
import { PollNode } from "./poll-node";

export function $isPollNode(node: LexicalNode | null | undefined): node is PollNode {
  return node instanceof PollNode;
}
